import { ActionError } from '../services/api/ActionError'
import type { ActionFeedback } from '../types'

// Reduces a caught error into an ActionFeedback. A 409 becomes a distinct `conflict`
// feedback; anything else an `error`. `mapErrorFn` lets a caller add endpoint-specific
// handling (e.g. mapping a 404 to `notFound`) that takes precedence when it returns
// a feedback object.
export function buildActionErrorFeedback(
  error: unknown,
  mapErrorFn?: (error: ActionError) => ActionFeedback | null,
): ActionFeedback {
  if (error instanceof ActionError) {
    const mapped = mapErrorFn?.(error)
    if (mapped) {
      return mapped
    }
    if (error.status === 409) {
      return { kind: 'conflict', message: error.message }
    }
    return { kind: 'error', message: error.message }
  }

  return {
    kind: 'error',
    message: error instanceof Error ? error.message : 'Unexpected error',
  }
}
